import { render, staticRenderFns } from "./ExchangeAddOrEdit.vue?vue&type=template&id=50bd440a"
import script from "./ExchangeAddOrEdit.vue?vue&type=script&lang=js"
export * from "./ExchangeAddOrEdit.vue?vue&type=script&lang=js"
import style0 from "./ExchangeAddOrEdit.vue?vue&type=style&index=0&id=50bd440a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports